var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCleaningWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.11 267.28C74.171 304.69 110.702 330.5 152.864 330.5H176.745C218.907 330.5 255.439 304.69 270.499 267.28C262.552 267.28 63.287 267.28 59.11 267.28V267.28Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.946 483.39L203.797 423.84C209.547 405.05 227.118 392 246.829 392H290.691L297.431 330.95L304.461 267.28H302.271C285.92 321.78 235.548 360.5 176.745 360.5H152.864C94.061 360.5 43.699 321.79 27.348 267.28H25.158L28.838 300.68L50.68 498.64C51.52 506.25 57.94 512 65.59 512H184.375C181.265 503.3 180.925 493.8 183.565 484.6C183.686 484.2 183.816 483.79 183.946 483.39V483.39Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M511.41 492.88L491.409 432.88C489.569 426.44 483.689 422 476.988 422H246.828C240.128 422 234.247 426.44 232.407 432.88L212.406 492.88C209.665 502.433 216.863 512 226.827 512H496.99C506.929 512 514.163 502.471 511.41 492.88V492.88Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M376.904 15C376.904 6.72 370.194 0 361.903 0C353.623 0 346.902 6.72 346.902 15V392H376.903V15H376.904Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M329.652 222.298V222.269C329.652 213.993 322.943 207.284 314.667 207.284H14.985C6.709 207.283 0 213.993 0 222.269V222.298C0 230.574 6.709 237.283 14.985 237.283H314.667C322.943 237.283 329.652 230.574 329.652 222.298Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaningWhite);
export default __webpack_public_path__ + "static/media/cleaning-white.0319dc079636e516164da9012a09282c.svg";
export { ForwardRef as ReactComponent };